// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"70":"475a6d28","247":"cba3f1b3","583":"5bd8998f","710":"fca31d22","878":"9e5407b0","983":"33898aa8"}[chunkId] + ".chunk.js";
};